<template>
  <div class="big_img">
    <div class="title">
      <div class="left_box">
        <span class="close_text iconfont iconchevron-left" @click="closePopup" v-show="!isWxMini"/>
        <!--              <i class="close_text iconfont iconchevron-left"></i>-->
        <span class="index_length">{{ slideIndex + 1 }}/{{ imgObjList.length }}</span>
      </div>
      <i class="trash iconfont icontrash-" v-show="isDel" @click="$emit('delImg',slideIndex)"></i>
    </div>
    <div class="img_body" v-if="slideState" @click="closePopup">
      <cube-slide ref="slide" :data="imgObjList" :initialIndex="imgIndex" :refreshResetCurrent="false" :showDots="false"
                  :loop="true" :auto-play="false" @change="imgChange">
        <cube-slide-item v-for="(item, index) in imgObjList" :key="index" @click.native="clickHandler(item, index)">
          <div class="img-container">
            <cube-scroll :data="[item.image]" style="justify-content: center;align-items: center;display:flex;">
              <img :src="item.image">
            </cube-scroll>
          </div>
        </cube-slide-item>
      </cube-slide>
    </div>
  </div>
</template>

<script>
	import { envMixin } from '../../../assets/js/mixin/global'

	export default {
		name: 'big-img',
		mixins: [ envMixin ],
		props: {
			imgList: Array,
			imgIndex: Number,
			state: Boolean,
			isDel: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			state: {
				handler (state) {
					if (state) {
						this.imgObjList = this.imgList.map(item => {
							return { url: '', image: item }
						})
						this.slideIndex = this.imgIndex
						this.slideState = true
					}
				}
			},
		},
		data () {
			return {
				imgObjList: [],
				slideState: false,
				slideIndex: 0
			}
		},
		mounted () {

		},
		beforeDestroy () {
		},
		methods: {
			clickHandler (obj, index) {
				// console.log(obj,index,"======>obj")
			},
			imgChange (index) {
				this.slideIndex = index
				// console.log(this.slideIndex,"======>")
			},
			closePopup () {
				this.$refs.slide && this.$refs.slide.refresh()
				this.slideState = false
				this.$emit('closeBigImg')
			},
		}
	}
</script>

<style lang="scss">
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  //.big_img_container{
  //  width: 100vw;
  //  height: 100vh;
  //  position: fixed;
  //  left: 0;
  //  top: 0;
  //  z-index: 999;
  //}
  .cube-image-preview {
    z-index: 999 !important;
    //height: calc(100% - 50px);
    //margin-top: 50px;
  }

  .img_body {
    width: 100vw;
    height: calc(100vh - 44px);
    //padding: 0 24px;
    background-color: #000;
    //overflow: hidden;
    display: flex;
    /*align-items: center;*/
    overflow: auto;
    .cube-slide {
      height: auto;
      /*margin-top: 30px;*/
      .cube-slide-group {
        //width: 100% !important;
        .cube-slide-item {
          width: 100vw;
          //height: 400px;
          .img-container {
            height: 100%;
            img {
              width: 100%;
              //height: 100%;
            }
          }
        }
      }
    }
  }


</style>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";


  .big_img {
    width: 100vw;
    height: 100vh;
    background-color: #fff;

    .title {
      width: 100%;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #404040;
      border-bottom: 1px solid #F4F4F4;
      font-size: $font-size-medium-x;

      .left_box {
        display: flex;
        align-items: center;
        .close_text {
          margin-left: 10px;
          font-weight: bold;
        }
        .iconfont {
          font-size: 26px;
          font-weight: bold;
          margin-right: 16px;
          &.iconmenu {
            font-weight: 400;
            font-size: 22px;
          }
        }

        .index_length {
          margin-left: 12px;
        }
      }

      .trash {
        margin-right: 24px;
      }
    }

  }
</style>
